import React, { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import { Layout } from "antd";
import DarkNavbar from "../landingPage/header/DarkNavbar";
import Footer from "../landingPage/footer";
import CookieConsentBanner from "../cookieConsentBanner";
import HeroSection from "./HeroSection/HeroSection";
import MetaTagContents from "../../MetaTagContents";
import "./LandingV2.scss";

const AssetsSection     = lazy(() => import("./AssetsSection/AssetsSection"));
const ValuePropsSection = lazy(() => import("./ValuePropsSection/ValuePropsSection"));
const WorkflowSection   = lazy(() => import("./WorkflowSection/WorkflowSection"));
const SpatialSection    = lazy(() => import("./SpatialSection/SpatialSection"));
const FaqSection        = lazy(() => import("./FaqSection/FaqSection"));
const CtaSection        = lazy(() => import("./CtaSection/CtaSection"));

const LandingV2 = () => {
    return (
        <div className="landing-v2">
            <Helmet>
                <title>{MetaTagContents.LANDING_V2.title}</title>
                <meta name="description" content={MetaTagContents.LANDING_V2.content} />
                <link rel="canonical" href="https://all3d.ai/" />

                {/* Open Graph — controls link previews on Slack, LinkedIn, Twitter, etc. */}
                <meta property="og:type"        content="website" />
                <meta property="og:url"         content="https://all3d.ai/" />
                <meta property="og:title"       content={MetaTagContents.LANDING_V2.title} />
                <meta property="og:description" content={MetaTagContents.LANDING_V2.content} />
                <meta property="og:image"       content="https://all3d.ai/featured/Logo.png" />

                {/* Twitter Card */}
                <meta name="twitter:card"        content="summary_large_image" />
                <meta name="twitter:title"       content={MetaTagContents.LANDING_V2.title} />
                <meta name="twitter:description" content={MetaTagContents.LANDING_V2.content} />
                <meta name="twitter:image"       content="https://all3d.ai/featured/Logo.png" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify(MetaTagContents.LANDING_V2.schemaMarkup.organization)}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify(MetaTagContents.LANDING_V2.schemaMarkup.softwareApplication)}
                </script>
            </Helmet>
            <CookieConsentBanner />
            <DarkNavbar hideCta />
            <Layout className="top-margins" role="main">
                <HeroSection />
                <Suspense fallback={null}>
                    <AssetsSection />
                    <ValuePropsSection />
                    <WorkflowSection />
                    <SpatialSection />
                    <FaqSection />
                    <CtaSection />
                </Suspense>
            </Layout>
            <Footer />
        </div>
    );
};

export default LandingV2;
